import type { FC } from 'react';
import { createPortal } from 'react-dom';
import usePortal from '@/hooks/usePortal';

interface Props {
  portalId?: string;
}

const Portal: FC<Props> = ({ portalId, children }) => {
  const portal = usePortal(portalId || 'tooltip-portal', false);
  if (portal) {
    return createPortal(children, portal);
  }
  return null;
};

export default Portal;
